import IconError from "@mui/icons-material/Error";
import IconFace from "@mui/icons-material/Face";
import { IUiAvatarProps, UiAvatar, UiBox } from "@smp/ui";
import clsx from "clsx";

import {
  IImageProxifiedProps,
  ImageProxified,
} from "@/components/ui/image_proxified";

import classesLocal from "./avatar_proxified.module.css";

export const AvatarProxified = ({
  src,
  isError,
  classes,
  ImageProps,
  children,
  ...props
}: Omit<IUiAvatarProps, "src" | "classes"> & {
  src?: IUiAvatarProps["src"] | null;
  isError?: boolean;
  classes?: IUiAvatarProps["classes"] & {
    box?: string;
  };
  ImageProps?: IImageProxifiedProps;
}) => {
  const { box: classBox, ...avatarClasses } = classes || {};

  return (
    <UiAvatar classes={avatarClasses} {...props}>
      {children ? (
        children
      ) : (
        <UiBox
          className={clsx(
            classBox,
            classesLocal.avatar,
            isError && classesLocal.avatar_error,
          )}
        >
          {isError ? (
            <IconError
              className={clsx(
                classesLocal.avatar__icon,
                classesLocal.avatar__icon_error,
              )}
            />
          ) : (
            <IconFace
              className={clsx(
                classesLocal.avatar__icon,
                classesLocal.avatar__icon_empty,
              )}
            />
          )}

          {src && !isError && (
            <ImageProxified
              src={src}
              className={classesLocal.image}
              {...ImageProps}
            />
          )}
        </UiBox>
      )}
    </UiAvatar>
  );
};
